import React, { useEffect, useState } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Button } from '../ui/button';
import { Badge } from '../ui/badge';
import { adminAPI } from '../../api';
import LoadingSpinner from '../LoadingSpinner';
import { toast } from 'sonner';
import { Download } from 'lucide-react';

const AdminCars = () => {
  const [cars, setCars] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const res = await adminAPI.getAllCars();
        setCars(res.data || []);
      } catch (e) {
        toast.error('Error cargando autos');
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  const exportCSV = async () => {
    try {
      const res = await adminAPI.exportCSV('cars');
      const blob = new Blob([res.data], { type: 'text/csv' });
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `cars_${Date.now()}.csv`;
      a.click();
      URL.revokeObjectURL(url);
    } catch (e) {
      toast.error('Error exportando');
    }
  };

  if (loading) return <div className="py-12 flex justify-center"><LoadingSpinner /></div>;

  return (
    <Card data-testid="admin-cars-card">
      <CardHeader className="flex flex-row items-center justify-between">
        <CardTitle>Autos ({cars.length})</CardTitle>
        <Button onClick={exportCSV} variant="outline" size="sm" data-testid="export-cars-csv-btn">
          <Download className="w-4 h-4 mr-2" /> Exportar CSV
        </Button>
      </CardHeader>
      <CardContent>
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4">
          {cars.map(c => (
            <div key={c.id} className="border rounded-lg overflow-hidden hover:shadow-md transition" data-testid={`car-row-${c.id}`}>
              {c.images?.[0] && (
                <img src={c.images[0]} alt={c.name} className="w-full h-32 object-cover" />
              )}
              <div className="p-3">
                <p className="font-medium">{c.name}</p>
                <p className="text-xs text-gray-500">{c.location}</p>
                <div className="flex justify-between items-center mt-2">
                  <span className="text-sm font-bold">${c.price_per_day} MXN/día</span>
                  {c.available ? <Badge className="bg-green-600">Disponible</Badge> : <Badge variant="outline">No disp.</Badge>}
                </div>
              </div>
            </div>
          ))}
        </div>
      </CardContent>
    </Card>
  );
};

export default AdminCars;
